import type { FC } from 'react';
import {
  Container,
  CoverContainer,
  CoverImage,
  Gradient,
  Content,
} from './styled';
import { Helmet } from 'react-helmet-async';

interface Props {
  alt?: string;
  imageSource?: string;
  imageSourceSet?: string;
  width?: number;
  height?: number;
}

export const ImageHeader: FC<Props> = ({
  imageSource,
  imageSourceSet,
  alt = 'Header cover image',
  children,
  width,
  height,
}) => {
  return (
    <Container>
      <CoverContainer>
        <Gradient />
        {typeof imageSource === 'string' && imageSource !== '' ? (
          <>
            <Helmet>
              <link
                rel="preload"
                as="image"
                href={imageSource}
                imageSrcSet={imageSourceSet}
              />
            </Helmet>
            <CoverImage
              data-cy-id="header-cover-image"
              src={imageSource}
              srcSet={imageSourceSet}
              alt={alt}
              width={width}
              height={height}
            />
          </>
        ) : null}
      </CoverContainer>
      {typeof children !== 'undefined' && <Content>{children}</Content>}
    </Container>
  );
};
